export const ADMIN_MODULES = [
  { key: "dashboard", label: "Tableau de bord", icon: "fa-chart-pie" },
  { key: "statistiques", label: "Statistiques", icon: "fa-chart-bar" },
  { key: "clients", label: "Gestion des clients", icon: "fa-user-plus" },
  { key: "orders", label: "Commandes Efashion", icon: "fa-store" },
  {
    key: "groupages",
    label: "Gestion des groupages",
    icon: "fa-boxes-stacked",
  },
  {
    key: "groupages-change-status",
    label: "Modifier les statuts des groupages",
    icon: "fa-lock",
  },
  { key: "ruptures", label: "Tableau des ruptures", icon: "fa-box-open" },
  { key: "mel-template", label: "Données template MEL", icon: "fa-file-excel" },
  { key: "couleurs", label: "Couleurs officielles", icon: "fa-palette" },
  { key: "code-promos", label: "Codes promos", icon: "fa-tags" },
  { key: "facturation", label: "Facturation", icon: "fa-file-invoice" },
  {
    key: "vendeur-facturation",
    label: "Facturation vendeurs",
    icon: "fa-file-invoice-dollar",
  },
  { key: "actualites", label: "Actualités", icon: "fa-bullhorn" },
  { key: "cms", label: "Pages et widgets", icon: "fa-window-maximize" },
  { key: "litige-retour", label: "Litige & retour", icon: "fa-gavel" },
  { key: "top-acheteurs", label: "Top Acheteur", icon: "fa-trophy" },
  {
    key: "nouveaux-acheteurs",
    label: "Nouveaux acheteurs",
    icon: "fa-user-clock",
  },
  {
    key: "grossistes-a-recontacter",
    label: "Grossistes à recontacter",
    icon: "fa-phone-volume",
  },
  { key: "shooting", label: "Shooting", icon: "fa-camera" },
  {
    key: "edit-siret-tva",
    label: "Modifier SIRET / TVA",
    icon: "fa-id-card",
  },
] as const;

export type AdminPermissionKey = (typeof ADMIN_MODULES)[number]["key"];

export const ADMIN_PERMISSION_ROUTES: Record<AdminPermissionKey, string> = {
  dashboard: "/adminEFP/dashboard",
  statistiques: "/adminEFP/statistiques",
  clients: "/adminEFP/nouveaux-comptes",
  orders: "/adminEFP/orders",
  groupages: "/adminEFP/groupages",
  "groupages-change-status": "/adminEFP/groupages",
  ruptures: "/adminEFP/commandes-rupture",
  "mel-template": "/adminEFP/mel-template",
  couleurs: "/adminEFP/couleurs",
  "code-promos": "/adminEFP/code-promos",
  facturation: "/adminEFP/facturation",
  "vendeur-facturation": "/adminEFP/vendeur-facturation",
  actualites: "/adminEFP/actualites",
  cms: "/adminEFP/cms/widgets",
  "litige-retour": "/adminEFP/litige-retour",
  "top-acheteurs": "/adminEFP/top-acheteurs",
  "nouveaux-acheteurs": "/adminEFP/nouveaux-acheteurs",
  "grossistes-a-recontacter": "/adminEFP/grossistes-a-recontacter",
  shooting: "/adminEFP/shooting/modeles",
  "edit-siret-tva": "/adminEFP/nouveaux-comptes",
};

export function permissionForAdminPath(
  path: string
): AdminPermissionKey | null {
  if (path === "/adminEFP/photos") return "dashboard";
  if (path.startsWith("/adminEFP/hipay")) return "clients";
  if (path.startsWith("/adminEFP/acheteur-statement")) return "clients";
  if (path.startsWith("/adminEFP/vendeur-fiche")) return "clients";
  if (path.startsWith("/adminEFP/groupage-detail/")) return "groupages";
  if (path.startsWith("/adminEFP/shopify")) return "shooting";
  if (path.startsWith("/adminEFP/pickupreturn")) return "shooting";
  if (path.startsWith("/adminEFP/shooting")) return "shooting";
  if (path.startsWith("/adminEFP/cms")) return "cms";
  if (path.startsWith("/adminEFP/store-prestations")) return "cms";

  for (const [key, route] of Object.entries(ADMIN_PERMISSION_ROUTES)) {
    if (key === "edit-siret-tva" || key === "groupages-change-status") continue;
    if (path === route || path.startsWith(`${route}/`)) {
      return key as AdminPermissionKey;
    }
  }
  return null;
}
